import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Col, Row } from 'react-bootstrap';
import { FaLinkedinIn, FaInstagram, FaFacebookF } from "react-icons/fa";
import '../styles/footer.css';

const Footer = () => {

    return (
        <>
            <footer className="footer text-dark pt-5 border-top">
                <Container>
                    <Row className="gy-4">
                        {/* Menu */}
                        <Col md={3} sm={6}>
                            <h6 className="fw-bold text-danger mb-3 textcenter">Quick links</h6>
                            <ul className="list-unstyled">
                                <li className='textcenter'><a href="/" className="text-dark">Home</a></li>
                                <li className='textcenter'><a href="#products" className="text-dark">Craftsmanship</a></li>
                                <li className='textcenter'><a href="#about" className="text-dark">Testimonial</a></li>
                                <li className='textcenter'><a href="#sustain" className="text-dark">About Us</a></li>
                                <li className='textcenter'><a href="#career" className="text-dark">Contact Us</a></li>
                            </ul>
                        </Col>

                        {/* Contact */}
                        <Col md={3} sm={6}>
                            <h6 className="fw-bold text-danger mb-3 textcenter">Contact</h6>
                            <p className="mb-1 textcenter">Chamunda Tailor</p>
                            <p className="mb-1 textcenter">Surat, Gujarat, India</p>
                            <p className="mb-1 textcenter">+91 9825928485</p>
                            <p className="mb-1 textcenter">uniform.ct@gmail.com</p>
                            <div className="d-flex gap-3 mt-3 jcc displayed">
                                <a href="/" className="text-dark"><FaLinkedinIn /></a>
                                <a href="/" className="text-dark"><FaInstagram /></a>
                                <a href="/" className="text-dark"><FaFacebookF /></a>
                            </div>
                        </Col>

                        {/* About */}
                        <Col md={6}>
                            <h6 className="fw-bold text-danger mb-3 textcenter">About us</h6>
                            <p style={{ maxWidth: "600px" }} className='textcenter'>
                                Chamunda Tailor Shop is Surat’s trusted uniform manufacturer for industries, hotels, and corporates.
                                We deliver high-quality customized uniforms made from Mafatlal fabrics, serving over 60% of Surat’s
                                diamond and jewelry companies.
                            </p>
                            <div className="d-flex gap-3 mt-3 jcc displayed-2">
                                <a href="/" className="text-dark"><FaLinkedinIn /></a>
                                <a href="/" className="text-dark"><FaInstagram /></a>
                                <a href="/" className="text-dark"><FaFacebookF /></a>
                            </div>
                        </Col>
                    </Row>

                    <hr className="my-4" />

                    {/* Bottom bar */}
                    <Row className="align-items-center text-center text-md-start">
                        <Col md={6}>
                            <small className="text-muted">
                                © {new Date().getFullYear()} Chamunda Tailor Shop. All Rights Reserved.
                            </small>
                        </Col>
                        <Col md={6} className="text-md-end mt-2 mt-md-0">
                            <small>
                                <a href="#privacy" className="text-muted mx-2">Privacy Policy</a> |
                                <a href="#terms" className="text-muted mx-2">Disclaimer</a>
                            </small>
                        </Col>
                    </Row>
                </Container>
                <br />
            </footer>

        </>
    );
};

export default Footer;
